import getCalendarFoldersOperation from 'owa-service/lib/operation/getCalendarFoldersOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Makes the call to the server to get all calendar folders and groups configuration
 * @returns promise of GetCalendarFoldersResponse type
 */
export default function loadSharedCalendarsConfiguration() {
    return getCalendarFoldersOperation({
        Header: getJsonRequestHeader(),
    }).then(function (response) {
        if (response && response.WasSuccessful) {
            return response;
        }
        else {
            throw new Error("getCalendarFoldersOperation " + response.ErrorCode);
        }
    });
}
//# sourceMappingURL=loadSharedCalendarsConfiguration.js.map